<script>
  export let title
</script>

<section class="hero">
  <h1>{title}</h1>
</section>

<style lang="scss">
  @font-face {
    font-family: 'H1Font';
    src: url('../assets/fonts/vinque.ttf');
  }

  .hero {
    width: 100vw;
    min-height: 20vh;
    background-image: url('../assets/images/bg.jpg');

    display: flex;
    justify-content: center;
    align-items: center;

    h1 {
      font-family: 'H1Font';
      text-align: center;
      color: rgb(37, 37, 37);
    }
  }
</style>
